export default "__VITE_ASSET__VPIYuk77__"